import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import Toolbar from "@mui/material/Toolbar";
import Tooltip from "@mui/material/Tooltip";
import IconButton from "@mui/material/IconButton";
import React from "react";
import { Refresh } from "@mui/icons-material";

export default function Header({ setisrefreshed }) {
  const handlerefresh = () => {
    setisrefreshed((prev) => prev + 1);
  };
  return (
    <Box sx={{ flexGrow: 1, mb: "10px" }}>
      <AppBar position="static">
        <Toolbar sx={{ minHeight: 56 }}>
          <Box sx={{ flexGrow: 1, display: "flex", alignItems: "center" }}>
            <img
              src={require("../../../../assets/portant-logo-wordmark.svg")}
              height={22}
              alt="Portant"
              style={{ display: "block", width: "auto" }}
            />
          </Box>
          <Tooltip title="Refresh workflows" arrow>
            <IconButton onClick={handlerefresh} size="small" aria-label="Refresh workflows">
              <Refresh sx={{ width: 20, height: 20 }} />
            </IconButton>
          </Tooltip>
        </Toolbar>
      </AppBar>
    </Box>
  );
}
